/**
 * Do not edit directly, this file was auto-generated
 */

export const FormColorBackgroundInput = "#fff";
export const FormColorBackgroundDisabled = "#F6F6F7";
export const FormColorBackgroundOptional = "#F0E3FF";
export const FormColorBorderDefault = "#B1B4B5";
export const FormColorBorderDisabled = "#F6F6F7";
export const FormColorBorderFocus = "#000";
export const FormColorBorderError = "#FD7268";
export const FormColorBorderSuccess = "#49CC5D";
export const FormColorTextPlaceholder = "#73787B";
export const FormColorTextPlaceholderFocus = "#B1B4B5";
export const FormColorTextInput = "#000";
export const FormColorTextLabel = "#000";
export const FormColorTextHint = "#383C3E";
export const FormColorTextOptional = "#000";
export const FormColorTextValidation = "#000";
export const FormBorderWidth = "1px";
export const FormBorderRadiusDefault = "8px";
export const FormBorderRadiusOptional = "3px";
export const FormTextLabel = {
  fontFamily: "DM Sans",
  fontWeight: 500,
  lineHeight: "24px",
  fontSize: "16px",
  letterSpacing: "0%",
  paragraphSpacing: 0,
  textDecoration: "none",
  textCase: "none",
};
export const FormTextHint = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "15px",
  letterSpacing: "0%",
  paragraphSpacing: 0,
  textDecoration: "none",
  textCase: "none",
};
export const FormTextInputLarge = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "20px",
  letterSpacing: "0%",
  paragraphSpacing: 0,
  textDecoration: "none",
  textCase: "none",
};
export const FormTextInputSmall = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "16px",
  letterSpacing: "0%",
  paragraphSpacing: 0,
  textDecoration: "none",
  textCase: "none",
};
export const FormTextOptional = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "14px",
  letterSpacing: "0%",
  paragraphSpacing: 0,
  textDecoration: "none",
  textCase: "none",
};
export const FormTextValidation = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "14px",
  letterSpacing: "0%",
  paragraphSpacing: 0,
  textDecoration: "none",
  textCase: "none",
};
export const FormSpaceTextInline = "2px";
export const FormSpaceLargeRight = "20px";
export const FormSpaceLargeLeft = "20px";
export const FormSpaceLargeGap = "12px";
export const FormSpaceStackSmall = "8px";
export const FormSpaceStackLarge = "12px";
export const FormSpaceLabelInline = "8px";
export const FormSpaceLabelBottom = "8px";
export const FormSpaceLabelStack = "4px";
export const FormSpaceSmallLeft = "16px";
export const FormSpaceSmallRight = "16px";
export const FormSpaceValidationHintTop = "4px";
export const FormSpaceValidationHintBottom = "4px";
export const FormSpaceValidationHintLeft = "8px";
export const FormSpaceValidationHintRight = "8px";
export const FormSpaceOptionalLabelTop = "2px";
export const FormSpaceOptionalLabelBottom = "2px";
export const FormSpaceOptionalLabelRight = "4px";
export const FormSpaceOptionalLabelLeft = "4px";
export const FormSpaceTextAreaSmall = "16px";
export const FormSpaceTextAreaLarge = "20px";
export const FormSpaceToolBarTop = "8px";
export const FormSpaceToolBarBottom = "8px";
export const FormSpaceToolBarLeft = "8px";
export const FormSpaceToolBarRight = "20px";
export const FormSizeLarge = "56px";
export const FormSizeMedium = "48px";
export const FormSizeTextArea = 140;
export const FormSizeSmall = "40px";
